// extracted by mini-css-extract-plugin
module.exports = {"tagsList":"inputTags_tagsList__2jSmo","tag":"inputTags_tag__yelYU","tagText":"inputTags_tagText__XdUpa","tooltip":"inputTags_tooltip__3iQil"};